import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { SharedModule } from '../shared.module';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
     standalone: true, 
        imports: [ CommonModule], 

    
})
export class FooterComponent {
  year: Date = new Date();
  version = environment.version;
}
